/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export interface UserInputFilePartWithUrl {
  type: "input_file_with_url";
  url: string;
  filename: string;
  content_type: string;
}
